export { default } from "@/app/(app)/home/find-me-online/index";
